// import React, { useState } from 'react';
// import { 
//   Heart, 
//   Building, 
//   MapPin, 
//   Phone, 
//   Mail, 
//   Globe, 
//   Bed, 
//   Stethoscope,
//   User,
//   Upload,
//   FileText,
//   CreditCard,
//   Lock,
//   Eye,
//   EyeOff,
//   CheckCircle,
//   AlertCircle,
//   ArrowLeft,
//   ArrowRight,
//   X,
//   Loader,
//   Camera,
//   Calendar
// } from 'lucide-react';
// import { registerHospital } from '../../services/hospitalService';

// const HospitalRegistration = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [submitSuccess, setSubmitSuccess] = useState(false);
//   const [applicationId, setApplicationId] = useState('');

//   // Form data state
//   const [formData, setFormData] = useState({
//     hospitalName: '',
//     address: '',
//     city: '',
//     state: '',
//     pincode: '',
//     phone: '',
//     email: '',
//     website: '',
//     numberOfBeds: '',
//     facilities: [],
//     specialities: [],
//     mdName: '',
//     mdContact: '',
//     mdEmail: '',
//     representativeName: '',
//     designation: '',
//     representativeEmail: '',
//     representativePhone: '',
//     mdAsRepresentative: false,
//     accountEmail: '',
//     password: '',
//     confirmPassword: '',
//     bankName: '',
//     accountNumber: '',
//     ifscCode: '',
//     accountHolderName: '',
//     registrationNumber: '',
//     registrationValidityDate: '',
//     hasNABH: false,
//     hasQualityCouncil: false,
//     pharmacyType: '',
//     dlNumber: ''
//   });

//   // Documents state
//   const [documents, setDocuments] = useState({
//     registrationCert: null,
//     nabhCert: null,
//     qualityCouncilCert: null,
//     pharmacyCert: null,
//     facilitiesPhotos: [],
//     medicalEstablishmentCert: null,
//     authorizationLetter: null,
//     cancelledCheque: null,
//     panDocument: null,
//     gstDocument: null,
//     roomTariff: null,
//     procedureTariff: null
//   });

//   // UI state
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [uploadProgress, setUploadProgress] = useState({});

//   // Constants
//   const steps = [
//     { id: 1, title: 'Basic Information', icon: Building },
//     { id: 2, title: 'Hospital Details', icon: Bed },
//     { id: 3, title: 'Contact Information', icon: User },
//     { id: 4, title: 'Documents', icon: FileText },
//     { id: 5, title: 'Account & Banking', icon: CreditCard },
//     { id: 6, title: 'Review & Submit', icon: CheckCircle }
//   ];

//   const facilities = [
//     'Emergency Services', 'ICU', 'Operation Theatre', 'Laboratory', 'Radiology',
//     'Pharmacy', 'Blood Bank', 'Dialysis', 'Physiotherapy', 'Ambulance Service',
//     'Cafeteria', 'Parking', '24/7 Services', 'Oxygen Plant', 'CCTV Surveillance'
//   ];

//   const specialities = [
//     'Cardiology', 'Orthopedics', 'Neurology', 'Pediatrics', 'Gynecology',
//     'Oncology', 'Dermatology', 'ENT', 'Ophthalmology', 'Psychiatry',
//     'General Surgery', 'Anesthesiology', 'Radiology', 'Pathology', 'Emergency Medicine',
//     'Internal Medicine', 'Urology', 'Gastroenterology', 'Pulmonology', 'Nephrology'
//   ];

//   const states = [
//     'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
//     'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
//     'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
//     'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
//     'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
//   ];

//   const documentConfig = [
//     { key: 'registrationCert', label: 'Hospital Registration Certificate (as per Medical Establishment Act)', required: true },
//     { key: 'nabhCert', label: 'NABH Certificate', required: false, conditional: 'hasNABH' },
//     { key: 'qualityCouncilCert', label: 'Quality Council of India Certificate', required: false, conditional: 'hasQualityCouncil' },
//     { key: 'pharmacyCert', label: 'Pharmacy Certificate', required: false, conditional: 'pharmacyType' },
//     { key: 'facilitiesPhotos', label: 'Facilities Photos (Infrastructure)', required: true, multiple: true },
//     { key: 'medicalEstablishmentCert', label: 'Medical Establishment Act Certificate', required: false },
//     { key: 'authorizationLetter', label: 'Authorization Letter', required: false },
//     { key: 'cancelledCheque', label: 'Cancelled Cheque', required: false },
//     { key: 'panDocument', label: 'Hospital PAN Document', required: false },
//     { key: 'gstDocument', label: 'GST Certificate', required: false },
//     { key: 'roomTariff', label: 'Hospital Room Tariff Document', required: false },
//     { key: 'procedureTariff', label: 'Procedure Tariff Document', required: false }
//   ];

//   // Event handlers
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     const newValue = type === 'checkbox' ? checked : value;

//     setFormData(prev => {
//       const updated = { ...prev, [name]: newValue };

//       // Auto-fill representative data if MD is representative
//       if (name === 'mdAsRepresentative' && checked) {
//         updated.representativeName = updated.mdName;
//         updated.representativeEmail = updated.mdEmail;
//         updated.representativePhone = updated.mdContact;
//         updated.designation = 'Managing Director';
//       } else if (name === 'mdAsRepresentative' && !checked) {
//         updated.representativeName = '';
//         updated.representativeEmail = '';
//         updated.representativePhone = '';
//         updated.designation = '';
//       }

//       // Auto-fill when MD details change and MD is representative
//       if (updated.mdAsRepresentative) {
//         if (name === 'mdName') updated.representativeName = value;
//         if (name === 'mdEmail') updated.representativeEmail = value;
//         if (name === 'mdContact') updated.representativePhone = value;
//       }

//       return updated;
//     });

//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const handleMultiSelect = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: prev[field].includes(value)
//         ? prev[field].filter(item => item !== value)
//         : [...prev[field], value]
//     }));
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   const handleFileUpload = (docType, file, isMultiple = false) => {
//     if (!file) return;

//     // Validate file
//     const maxSize = 5 * 1024 * 1024; // 5MB
//     const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

//     if (file.size > maxSize) {
//       setErrors(prev => ({ ...prev, [docType]: 'File size should be less than 5MB' }));
//       return;
//     }

//     if (!allowedTypes.includes(file.type)) {
//       setErrors(prev => ({ ...prev, [docType]: 'Please upload PDF, JPEG, or PNG files only' }));
//       return;
//     }

//     if (isMultiple) {
//       setDocuments(prev => {
//         const currentPhotos = prev[docType] || [];
//         if (currentPhotos.length >= 8) {
//           setErrors(prevErr => ({ ...prevErr, [docType]: 'Maximum 8 photos allowed' }));
//           return prev;
//         }

//         // Create a structured object for multiple files
//         const fileObj = {
//           file: file,
//           name: file.name,
//           size: file.size,
//           type: file.type,
//           lastModified: file.lastModified,
//           id: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
//         };

//         return { ...prev, [docType]: [...currentPhotos, fileObj] };
//       });
//     } else {
//       setDocuments(prev => ({ ...prev, [docType]: file }));
//     }

//     setErrors(prev => ({ ...prev, [docType]: '' }));

//     // Simulate upload progress
//     const progressKey = isMultiple ? `${docType}_${Date.now()}` : docType;
//     setUploadProgress(prev => ({ ...prev, [progressKey]: 0 }));
//     const interval = setInterval(() => {
//       setUploadProgress(prev => {
//         const progress = (prev[progressKey] || 0) + 10;
//         if (progress >= 100) {
//           clearInterval(interval);
//           return { ...prev, [progressKey]: 100 };
//         }
//         return { ...prev, [progressKey]: progress };
//       });
//     }, 100);
//   };

//   const removeFile = (docType, index = null) => {
//     if (index !== null) {
//       // Remove specific photo
//       setDocuments(prev => ({
//         ...prev,
//         [docType]: prev[docType].filter((_, i) => i !== index)
//       }));
//     } else {
//       setDocuments(prev => ({ ...prev, [docType]: null }));
//     }
//     setUploadProgress(prev => ({ ...prev, [docType]: 0 }));
//   };

//   // Validation functions
//   const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone.replace(/\s+/g, ''));
//   const validatePincode = (pincode) => /^\d{6}$/.test(pincode);
//   const validateIFSC = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);

//   const validateStep = (step) => {
//     const newErrors = {};

//     switch (step) {
//       case 1: // Basic Information
//         if (!formData.hospitalName.trim()) newErrors.hospitalName = 'Hospital name is required';
//         if (!formData.address.trim()) newErrors.address = 'Address is required';
//         if (!formData.city.trim()) newErrors.city = 'City is required';
//         if (!formData.state) newErrors.state = 'State is required';
//         if (!formData.pincode.trim()) newErrors.pincode = 'Pincode is required';
//         else if (!validatePincode(formData.pincode)) newErrors.pincode = 'Invalid pincode format';
//         if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
//         else if (!validatePhone(formData.phone)) newErrors.phone = 'Invalid phone number';
//         if (!formData.email.trim()) newErrors.email = 'Email is required';
//         else if (!validateEmail(formData.email)) newErrors.email = 'Invalid email format';
//         if (!formData.registrationNumber.trim()) newErrors.registrationNumber = 'Registration number is required';
//         if (!formData.registrationValidityDate) newErrors.registrationValidityDate = 'Registration validity date is required';
//         break;

//       case 2: // Hospital Details
//         if (!formData.numberOfBeds) newErrors.numberOfBeds = 'Number of beds is required';
//         else if (parseInt(formData.numberOfBeds) < 1) newErrors.numberOfBeds = 'Must have at least 1 bed';
//         if (formData.facilities.length === 0) newErrors.facilities = 'Select at least one facility';
//         if (formData.specialities.length === 0) newErrors.specialities = 'Select at least one speciality';
//         if (!formData.pharmacyType) newErrors.pharmacyType = 'Please specify pharmacy type';
//         if (formData.pharmacyType === 'inhouse' && !formData.dlNumber.trim()) {
//           newErrors.dlNumber = 'DL number is required for in-house pharmacy';
//         }
//         break;

//       case 3: // Contact Information
//         if (!formData.mdName.trim()) newErrors.mdName = 'MD name is required';
//         if (!formData.mdContact.trim()) newErrors.mdContact = 'MD contact is required';
//         else if (!validatePhone(formData.mdContact)) newErrors.mdContact = 'Invalid MD contact number';
//         if (formData.mdEmail && !validateEmail(formData.mdEmail)) newErrors.mdEmail = 'Invalid MD email format';

//         if (!formData.mdAsRepresentative) {
//           if (!formData.representativeName.trim()) newErrors.representativeName = 'Representative name is required';
//           if (!formData.designation.trim()) newErrors.designation = 'Designation is required';
//           if (!formData.representativeEmail.trim()) newErrors.representativeEmail = 'Representative email is required';
//           else if (!validateEmail(formData.representativeEmail)) newErrors.representativeEmail = 'Invalid email format';
//           if (!formData.representativePhone.trim()) newErrors.representativePhone = 'Representative phone is required';
//           else if (!validatePhone(formData.representativePhone)) newErrors.representativePhone = 'Invalid phone number';
//         }
//         break;

//       case 4: // Documents
//         if (!documents.registrationCert) newErrors.registrationCert = 'Hospital Registration Certificate is required';
//         if (formData.hasNABH && !documents.nabhCert) newErrors.nabhCert = 'NABH Certificate is required';
//         if (formData.hasQualityCouncil && !documents.qualityCouncilCert) newErrors.qualityCouncilCert = 'Quality Council Certificate is required';
//         if (formData.pharmacyType === 'inhouse' && !documents.pharmacyCert) newErrors.pharmacyCert = 'Pharmacy Certificate is required';
//         if (!documents.facilitiesPhotos || documents.facilitiesPhotos.length < 4) {
//           newErrors.facilitiesPhotos = 'Minimum 4 facility photos are required';
//         }
//         break;

//       case 5: // Account & Banking
//         if (!formData.accountEmail.trim()) newErrors.accountEmail = 'Account email is required';
//         else if (!validateEmail(formData.accountEmail)) newErrors.accountEmail = 'Invalid email format';
//         if (!formData.password) newErrors.password = 'Password is required';
//         else if (formData.password.length < 8) newErrors.password = 'Password must be at least 8 characters';
//         if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm password is required';
//         else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
//         if (!formData.bankName.trim()) newErrors.bankName = 'Bank name is required';
//         if (!formData.accountNumber.trim()) newErrors.accountNumber = 'Account number is required';
//         if (!formData.ifscCode.trim()) newErrors.ifscCode = 'IFSC code is required';
//         else if (!validateIFSC(formData.ifscCode)) newErrors.ifscCode = 'Invalid IFSC code format';
//         if (!formData.accountHolderName.trim()) newErrors.accountHolderName = 'Account holder name is required';
//         break;
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Navigation
//   const nextStep = () => {
//     if (validateStep(currentStep)) {
//       setCurrentStep(prev => Math.min(prev + 1, 6));
//     }
//   };

//   const prevStep = () => {
//     setCurrentStep(prev => Math.max(prev - 1, 1));
//   };

//   // Submit
//   const handleSubmit = async () => {
//     if (!validateStep(5)) return;

//     setLoading(true);
//     try {
//       const documentsToUpload = {};

//       // Handle regular documents and facilities photos separately
//       Object.entries(documents).forEach(([key, file]) => {
//         if (file) {
//           if (key === 'facilitiesPhotos' && Array.isArray(file)) {
//             // Handle facilities photos as individual files with indexed keys
//             file.forEach((fileObj, index) => {
//               documentsToUpload[`facilitiesPhoto_${index}`] = fileObj.file;
//             });
//           } else {
//             documentsToUpload[key] = file;
//           }
//         }
//       });

//       console.log('Documents being sent:', documentsToUpload); // Debug log

//       const result = await registerHospital(formData, documentsToUpload);

//       if (result.success) {
//         setApplicationId(result.applicationId);
//         setSubmitSuccess(true);
//       } else {
//         setErrors({ submit: result.error });
//       }
//     } catch (error) {
//       console.error('Registration error:', error);
//       setErrors({ submit: 'Registration failed. Please try again.' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Render components
//   const renderFormField = (name, label, type = 'text', required = true, placeholder = '', options = {}) => (
//     <div>
//       <label className="form-label">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>
//       {type === 'select' ? (
//         <select
//           name={name}
//           value={formData[name]}
//           onChange={handleInputChange}
//           className={`input-field ${errors[name] ? 'input-error' : ''}`}
//         >
//           <option value="">{placeholder}</option>
//           {options.map(option => (
//             <option key={option} value={option}>{option}</option>
//           ))}
//         </select>
//       ) : type === 'textarea' ? (
//         <textarea
//           name={name}
//           value={formData[name]}
//           onChange={handleInputChange}
//           className={`input-field ${errors[name] ? 'input-error' : ''}`}
//           placeholder={placeholder}
//           rows={options.rows || 3}
//         />
//       ) : (
//         <input
//           type={type}
//           name={name}
//           value={formData[name]}
//           onChange={handleInputChange}
//           className={`input-field ${errors[name] ? 'input-error' : ''}`}
//           placeholder={placeholder}
//           min={options.min}
//           disabled={options.disabled}
//         />
//       )}
//       {errors[name] && <p className="form-error">{errors[name]}</p>}
//     </div>
//   );

//   const renderMultiSelect = (field, label, options, required = true) => (
//     <div>
//       <label className="form-label">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>
//       <p className="form-help mb-3">Select all that apply</p>
//       <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-48 overflow-y-auto">
//         {options.map(option => (
//           <label key={option} className="flex items-center space-x-2 cursor-pointer">
//             <input
//               type="checkbox"
//               checked={formData[field].includes(option)}
//               onChange={() => handleMultiSelect(field, option)}
//               className="rounded border-gray-300 text-primary-500 focus:ring-primary-500"
//             />
//             <span className="text-sm text-gray-700">{option}</span>
//           </label>
//         ))}
//       </div>
//       {errors[field] && <p className="form-error">{errors[field]}</p>}
//     </div>
//   );

//   const renderPasswordField = (name, label, showState, setShowState) => (
//     <div>
//       <label className="form-label">{label} <span className="text-red-500">*</span></label>
//       <div className="relative">
//         <input
//           type={showState ? 'text' : 'password'}
//           name={name}
//           value={formData[name]}
//           onChange={handleInputChange}
//           className={`input-field pr-10 ${errors[name] ? 'input-error' : ''}`}
//           placeholder={`Enter ${label.toLowerCase()}`}
//         />
//         <button
//           type="button"
//           onClick={() => setShowState(!showState)}
//           className="absolute inset-y-0 right-0 pr-3 flex items-center"
//         >
//           {showState ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//         </button>
//       </div>
//       {errors[name] && <p className="form-error">{errors[name]}</p>}
//     </div>
//   );

//   const renderDocumentUpload = (doc) => {
//     if (doc.conditional) {
//       if (doc.conditional === 'hasNABH' && !formData.hasNABH) return null;
//       if (doc.conditional === 'hasQualityCouncil' && !formData.hasQualityCouncil) return null;
//       if (doc.conditional === 'pharmacyType' && formData.pharmacyType !== 'inhouse') return null;
//     }

//     if (doc.multiple) {
//       return (
//         <div key={doc.key} className="border border-gray-200 rounded-lg p-4">
//           <div className="flex items-center justify-between mb-3">
//             <h4 className="font-medium text-gray-800">
//               {doc.label} {doc.required && <span className="text-red-500">*</span>}
//             </h4>
//           </div>

//           <div className="mb-4">
//             <p className="text-sm text-gray-600 mb-2">Upload 4-8 photos of your hospital facilities</p>
//             <div className="dropzone p-6 text-center">
//               <Camera className="h-8 w-8 text-gray-400 mx-auto mb-2" />
//               <p className="text-sm text-gray-600 mb-2">Click to upload facility photos</p>
//               <p className="text-xs text-gray-500">JPEG, PNG up to 5MB each</p>
//               <input
//                 type="file"
//                 accept=".jpg,.jpeg,.png"
//                 multiple
//                 onChange={(e) => Array.from(e.target.files).forEach(file => handleFileUpload(doc.key, file, true))}
//                 className="hidden"
//                 id={doc.key}
//               />
//               <label htmlFor={doc.key} className="btn-primary mt-3 cursor-pointer">
//                 <Upload className="h-4 w-4 mr-2" />
//                 Choose Photos
//               </label>
//             </div>
//           </div>

//           {documents[doc.key] && documents[doc.key].length > 0 && (
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
//               {documents[doc.key].map((fileObj, index) => (
//                 <div key={fileObj.id || index} className="relative bg-green-50 border border-green-200 rounded-lg p-3">
//                   <button
//                     onClick={() => removeFile(doc.key, index)}
//                     className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
//                   >
//                     <X className="h-3 w-3" />
//                   </button>
//                   <div className="flex items-center space-x-2">
//                     <Camera className="h-4 w-4 text-green-600" />
//                     <div className="flex-1 min-w-0">
//                       <p className="text-xs font-medium text-green-800 truncate">{fileObj.name}</p>
//                       <p className="text-xs text-green-600">{(fileObj.size / 1024 / 1024).toFixed(2)} MB</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}

//           {documents[doc.key] && (
//             <p className="text-sm text-green-600 mt-2">
//               {documents[doc.key].length} photo(s) uploaded (minimum 4 required)
//             </p>
//           )}

//           {errors[doc.key] && <p className="form-error mt-2">{errors[doc.key]}</p>}
//         </div>
//       );
//     }

//     return (
//       <div key={doc.key} className="border border-gray-200 rounded-lg p-4">
//         <div className="flex items-center justify-between mb-3">
//           <h4 className="font-medium text-gray-800">
//             {doc.label} {doc.required && <span className="text-red-500">*</span>}
//           </h4>
//           {documents[doc.key] && (
//             <button onClick={() => removeFile(doc.key)} className="text-red-500 hover:text-red-700 p-1">
//               <X className="h-4 w-4" />
//             </button>
//           )}
//         </div>

//         {!documents[doc.key] ? (
//           <div className="dropzone p-6 text-center">
//             <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" />
//             <p className="text-sm text-gray-600 mb-2">Click to upload or drag and drop</p>
//             <p className="text-xs text-gray-500">PDF, JPEG, PNG up to 5MB</p>
//             <input
//               type="file"
//               accept=".pdf,.jpg,.jpeg,.png"
//               onChange={(e) => handleFileUpload(doc.key, e.target.files[0])}
//               className="hidden"
//               id={doc.key}
//             />
//             <label htmlFor={doc.key} className="btn-primary mt-3 cursor-pointer">
//               <Upload className="h-4 w-4 mr-2" />
//               Choose File
//             </label>
//           </div>
//         ) : (
//           <div className="bg-green-50 border border-green-200 rounded-lg p-4">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center space-x-3">
//                 <FileText className="h-5 w-5 text-green-600" />
//                 <div>
//                   <p className="text-sm font-medium text-green-800">{documents[doc.key].name}</p>
//                   <p className="text-xs text-green-600">{(documents[doc.key].size / 1024 / 1024).toFixed(2)} MB</p>
//                 </div>
//               </div>
//               <CheckCircle className="h-5 w-5 text-green-600" />
//             </div>
//             {uploadProgress[doc.key] && uploadProgress[doc.key] < 100 && (
//               <div className="mt-2">
//                 <div className="bg-green-200 rounded-full h-2">
//                   <div className="bg-green-600 h-2 rounded-full transition-all duration-300" style={{ width: `${uploadProgress[doc.key]}%` }} />
//                 </div>
//                 <p className="text-xs text-green-600 mt-1">{uploadProgress[doc.key]}% ready</p>
//               </div>
//             )}
//           </div>
//         )}

//         {errors[doc.key] && <p className="form-error mt-2">{errors[doc.key]}</p>}
//       </div>
//     );
//   };

//   const renderStepContent = () => {
//     if (submitSuccess) {
//       return (
//         <div className="text-center space-y-6">
//           <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto">
//             <CheckCircle className="h-10 w-10 text-green-600" />
//           </div>

//           <div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-2">Registration Submitted Successfully!</h3>
//             <p className="text-gray-600 mb-4">Your hospital registration has been submitted for review.</p>
//             <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
//               <p className="text-sm text-primary-800"><strong>Application ID:</strong> {applicationId}</p>
//               <p className="text-sm text-primary-600 mt-2">
//                 Please save this application ID for future reference. You will receive an email confirmation 
//                 and further updates on your registered email address.
//               </p>
//             </div>
//           </div>

//           <div className="space-y-3">
//             <p className="text-sm text-gray-600"><strong>What's Next?</strong></p>
//             <ul className="text-sm text-gray-600 space-y-1">
//               <li>• Our team will review your application within 2-3 business days</li>
//               <li>• You'll receive an email notification once approved</li>
//               <li>• After approval, you can login with your account credentials</li>
//               <li>• Start submitting insurance applications for your patients</li>
//             </ul>
//           </div>

//           <button onClick={() => window.location.href = '/'} className="btn-primary">
//             Return to Homepage
//           </button>
//         </div>
//       );
//     }

//     switch (currentStep) {
//       case 1: // Basic Information
//         return (
//           <div className="space-y-6">
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderFormField('hospitalName', 'Hospital Name', 'text', true, 'Enter hospital name')}
//               {renderFormField('phone', 'Phone Number', 'tel', true, '+91 XXXXX XXXXX')}
//             </div>
//             {renderFormField('address', 'Address', 'textarea', true, 'Enter complete address', { rows: 3 })}
//             <div className="grid md:grid-cols-3 gap-6">
//               {renderFormField('city', 'City', 'text', true, 'Enter city')}
//               {renderFormField('state', 'State', 'select', true, 'Select State', states)}
//               {renderFormField('pincode', 'Pincode', 'text', true, 'XXXXXX')}
//             </div>
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderFormField('email', 'Email Address', 'email', true, 'hospital@example.com')}
//               {renderFormField('website', 'Website', 'url', false, 'https://www.hospital.com')}
//             </div>
//             <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
//               <h4 className="font-semibold text-blue-800 mb-2">Registration Details</h4>
//               <p className="text-sm text-blue-600 mb-3">Hospital registration certificate details</p>
//               <div className="grid md:grid-cols-2 gap-6">
//                 {renderFormField('registrationNumber', 'Registration Number', 'text', true, 'Enter registration number')}
//                 {renderFormField('registrationValidityDate', 'Registration Validity Date', 'date', true)}
//               </div>
//             </div>
//           </div>
//         );

//       case 2: // Hospital Details
//         return (
//           <div className="space-y-6">
//             {renderFormField('numberOfBeds', 'Number of Beds', 'number', true, 'Enter number of beds', { min: 1 })}
//             {renderMultiSelect('facilities', 'Facilities Available', facilities)}
//             {renderMultiSelect('specialities', 'Medical Specialities', specialities)}

//             <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
//               <h4 className="font-semibold text-purple-800 mb-2">Pharmacy Information</h4>
//               <p className="text-sm text-purple-600 mb-3">Please specify your pharmacy setup</p>

//               <div className="space-y-4">
//                 <div>
//                   <label className="form-label">
//                     Pharmacy Type <span className="text-red-500">*</span>
//                   </label>
//                   <div className="space-y-2">
//                     <label className="flex items-center space-x-2 cursor-pointer">
//                       <input
//                         type="radio"
//                         name="pharmacyType"
//                         value="inhouse"
//                         checked={formData.pharmacyType === 'inhouse'}
//                         onChange={handleInputChange}
//                         className="text-purple-500 focus:ring-purple-500"
//                       />
//                       <span className="text-sm text-gray-700">In-house Pharmacy</span>
//                     </label>
//                     <label className="flex items-center space-x-2 cursor-pointer">
//                       <input
//                         type="radio"
//                         name="pharmacyType"
//                         value="outsourced"
//                         checked={formData.pharmacyType === 'outsourced'}
//                         onChange={handleInputChange}
//                         className="text-purple-500 focus:ring-purple-500"
//                       />
//                       <span className="text-sm text-gray-700">Outsourced Pharmacy</span>
//                     </label>
//                   </div>
//                   {errors.pharmacyType && <p className="form-error">{errors.pharmacyType}</p>}
//                 </div>

//                 {formData.pharmacyType === 'inhouse' && (
//                   <div>
//                     {renderFormField('dlNumber', 'Drug License (DL) Number', 'text', true, 'Enter DL number')}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         );

//       case 3: // Contact Information
//         return (
//           <div className="space-y-6">
//             <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-200">
//               <h4 className="font-semibold text-secondary-800 mb-2">Managing Director (MD)</h4>
//               <p className="text-sm text-secondary-600">Hospital's managing director information</p>
//             </div>
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderFormField('mdName', 'MD Name', 'text', true, 'Dr. Full Name')}
//               {renderFormField('mdContact', 'MD Contact', 'tel', true, '+91 XXXXX XXXXX')}
//             </div>
//             {renderFormField('mdEmail', 'MD Email', 'email', false, 'md@hospital.com')}

//             <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
//               <label className="flex items-center space-x-3 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   name="mdAsRepresentative"
//                   checked={formData.mdAsRepresentative}
//                   onChange={handleInputChange}
//                   className="rounded border-amber-300 text-amber-500 focus:ring-amber-500"
//                 />
//                 <div>
//                   <span className="font-medium text-amber-800">MD will act as Hospital Representative</span>
//                   <p className="text-sm text-amber-600">Check this if MD will be the primary contact for this application</p>
//                 </div>
//               </label>
//             </div>

//             {!formData.mdAsRepresentative && (
//               <>
//                 <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
//                   <h4 className="font-semibold text-primary-800 mb-2">Hospital Representative</h4>
//                   <p className="text-sm text-primary-600">Primary contact person for this application</p>
//                 </div>
//                 <div className="grid md:grid-cols-2 gap-6">
//                   {renderFormField('representativeName', 'Representative Name', 'text', true, 'Full name')}
//                   {renderFormField('designation', 'Designation', 'text', true, 'e.g., Administrator, Manager')}
//                 </div>
//                 <div className="grid md:grid-cols-2 gap-6">
//                   {renderFormField('representativeEmail', 'Representative Email', 'email', true, 'representative@hospital.com')}
//                   {renderFormField('representativePhone', 'Representative Phone', 'tel', true, '+91 XXXXX XXXXX')}
//                 </div>
//               </>
//             )}
//           </div>
//         );

//       case 4: // Documents
//         return (
//           <div className="space-y-6">
//             <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
//               <div className="flex items-start space-x-3">
//                 <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" />
//                 <div>
//                   <h4 className="font-semibold text-amber-800">Document Requirements</h4>
//                   <p className="text-sm text-amber-700 mt-1">
//                     All documents must be clear, valid, and in PDF, JPEG, or PNG format (max 5MB each)
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Quality Certifications */}
//             <div className="bg-green-50 rounded-lg p-4 border border-green-200">
//               <h4 className="font-semibold text-green-800 mb-3">Quality Certifications</h4>
//               <div className="space-y-3">
//                 <label className="flex items-center space-x-3 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     name="hasNABH"
//                     checked={formData.hasNABH}
//                     onChange={handleInputChange}
//                     className="rounded border-green-300 text-green-500 focus:ring-green-500"
//                   />
//                   <span className="text-green-700">Hospital has NABH Certificate</span>
//                 </label>
//                 <label className="flex items-center space-x-3 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     name="hasQualityCouncil"
//                     checked={formData.hasQualityCouncil}
//                     onChange={handleInputChange}
//                     className="rounded border-green-300 text-green-500 focus:ring-green-500"
//                   />
//                   <span className="text-green-700">Hospital has Quality Council of India Certificate</span>
//                 </label>
//               </div>
//             </div>

//             <div className="grid gap-6">
//               {documentConfig.map(renderDocumentUpload)}
//             </div>
//           </div>
//         );

//       case 5: // Account & Banking
//         return (
//           <div className="space-y-6">
//             <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
//               <h4 className="font-semibold text-primary-800 mb-2">Account Information</h4>
//               <p className="text-sm text-primary-600">These credentials will be used to login after approval</p>
//             </div>
//             {renderFormField('accountEmail', 'Account Email', 'email', true, 'login@hospital.com')}
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderPasswordField('password', 'Password', showPassword, setShowPassword)}
//               {renderPasswordField('confirmPassword', 'Confirm Password', showConfirmPassword, setShowConfirmPassword)}
//             </div>

//             <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-200">
//               <h4 className="font-semibold text-secondary-800 mb-2">Bank Account Details</h4>
//               <p className="text-sm text-secondary-600">For reimbursement and payment processing</p>
//             </div>
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderFormField('bankName', 'Bank Name', 'text', true, 'Enter bank name')}
//               {renderFormField('accountHolderName', 'Account Holder Name', 'text', true, 'Account holder name')}
//             </div>
//             <div className="grid md:grid-cols-2 gap-6">
//               {renderFormField('accountNumber', 'Account Number', 'text', true, 'Enter account number')}
//               {renderFormField('ifscCode', 'IFSC Code', 'text', true, 'IFSC Code')}
//             </div>
//           </div>
//         );

//       case 6: // Review & Submit
//         return (
//           <div className="space-y-6">
//             <div className="bg-green-50 rounded-lg p-4 border border-green-200">
//               <div className="flex items-start space-x-3">
//                 <CheckCircle className="h-5 w-5 text-green-600 mt-0.5" />
//                 <div>
//                   <h4 className="font-semibold text-green-800">Review Your Information</h4>
//                   <p className="text-sm text-green-700 mt-1">
//                     Please review all information before submitting your application
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="space-y-4">
//               {/* Hospital Information */}
//               <div className="card">
//                 <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
//                   <Building className="h-5 w-5 mr-2 text-primary-500" />
//                   Hospital Information
//                 </h4>
//                 <div className="grid md:grid-cols-2 gap-4 text-sm">
//                   <div><span className="font-medium">Name:</span> {formData.hospitalName}</div>
//                   <div><span className="font-medium">Phone:</span> {formData.phone}</div>
//                   <div><span className="font-medium">Email:</span> {formData.email}</div>
//                   <div><span className="font-medium">Website:</span> {formData.website || 'Not provided'}</div>
//                   <div><span className="font-medium">Registration No:</span> {formData.registrationNumber}</div>
//                   <div><span className="font-medium">Validity Date:</span> {formData.registrationValidityDate}</div>
//                   <div className="md:col-span-2"><span className="font-medium">Address:</span> {formData.address}, {formData.city}, {formData.state} - {formData.pincode}</div>
//                 </div>
//               </div>

//               {/* Hospital Details */}
//               <div className="card">
//                 <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
//                   <Bed className="h-5 w-5 mr-2 text-primary-500" />
//                   Hospital Details
//                 </h4>
//                 <div className="grid md:grid-cols-2 gap-4 text-sm">
//                   <div><span className="font-medium">Number of Beds:</span> {formData.numberOfBeds}</div>
//                   <div><span className="font-medium">Pharmacy Type:</span> {formData.pharmacyType === 'inhouse' ? 'In-house' : 'Outsourced'}</div>
//                   {formData.pharmacyType === 'inhouse' && (
//                     <div><span className="font-medium">DL Number:</span> {formData.dlNumber}</div>
//                   )}
//                   <div className="md:col-span-2">
//                     <span className="font-medium">Facilities:</span> {formData.facilities.join(', ')}
//                   </div>
//                   <div className="md:col-span-2">
//                     <span className="font-medium">Specialities:</span> {formData.specialities.join(', ')}
//                   </div>
//                 </div>
//               </div>

//               {/* Contact Information */}
//               <div className="card">
//                 <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
//                   <User className="h-5 w-5 mr-2 text-primary-500" />
//                   Contact Information
//                 </h4>
//                 <div className="grid md:grid-cols-2 gap-4 text-sm">
//                   <div><span className="font-medium">MD Name:</span> {formData.mdName}</div>
//                   <div><span className="font-medium">MD Contact:</span> {formData.mdContact}</div>
//                   <div><span className="font-medium">MD Email:</span> {formData.mdEmail || 'Not provided'}</div>
//                   <div><span className="font-medium">Representative:</span> {formData.mdAsRepresentative ? 'Same as MD' : formData.representativeName}</div>
//                   {!formData.mdAsRepresentative && (
//                     <>
//                       <div><span className="font-medium">Designation:</span> {formData.designation}</div>
//                       <div><span className="font-medium">Rep. Email:</span> {formData.representativeEmail}</div>
//                       <div><span className="font-medium">Rep. Phone:</span> {formData.representativePhone}</div>
//                     </>
//                   )}
//                 </div>
//               </div>

//               {/* Documents */}
//               <div className="card">
//                 <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
//                   <FileText className="h-5 w-5 mr-2 text-primary-500" />
//                   Documents Uploaded
//                 </h4>
//                 <div className="grid md:grid-cols-2 gap-2 text-sm">
//                   {Object.entries(documents).map(([key, file]) => {
//                     if (key === 'facilitiesPhotos' && file && file.length > 0) {
//                       return (
//                         <div key={key} className="flex items-center space-x-2 md:col-span-2">
//                           <CheckCircle className="h-4 w-4 text-green-500" />
//                           <span>Facility Photos ({file.length} photos uploaded)</span>
//                         </div>
//                       );
//                     } else if (file && key !== 'facilitiesPhotos') {
//                       return (
//                         <div key={key} className="flex items-center space-x-2">
//                           <CheckCircle className="h-4 w-4 text-green-500" />
//                           <span>{file.name}</span>
//                         </div>
//                       );
//                     }
//                     return null;
//                   })}
//                 </div>
//               </div>

//               {/* Account & Bank Details */}
//               <div className="card">
//                 <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
//                   <CreditCard className="h-5 w-5 mr-2 text-primary-500" />
//                   Account & Bank Details
//                 </h4>
//                 <div className="grid md:grid-cols-2 gap-4 text-sm">
//                   <div><span className="font-medium">Account Email:</span> {formData.accountEmail}</div>
//                   <div><span className="font-medium">Bank Name:</span> {formData.bankName}</div>
//                   <div><span className="font-medium">Account Holder:</span> {formData.accountHolderName}</div>
//                   <div><span className="font-medium">IFSC Code:</span> {formData.ifscCode}</div>
//                 </div>
//               </div>
//             </div>

//             {/* Error Message */}
//             {errors.submit && (
//               <div className="bg-red-50 border border-red-200 rounded-lg p-4">
//                 <div className="flex items-center space-x-3">
//                   <AlertCircle className="h-5 w-5 text-red-600" />
//                   <p className="text-red-700">{errors.submit}</p>
//                 </div>
//               </div>
//             )}

//             {/* Terms & Conditions */}
//             <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
//               <div className="flex items-start space-x-3">
//                 <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" />
//                 <div>
//                   <h4 className="font-semibold text-amber-800">Terms & Conditions</h4>
//                   <p className="text-sm text-amber-700 mt-1">
//                     By submitting this application, you agree to our terms and conditions. Your application will be reviewed by our team and you will be notified of the approval status via email.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 py-8">
//       <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header */}
//         <div className="text-center mb-8">
//           <div className="flex items-center justify-center space-x-3 mb-4">
//             <div className="bg-gradient-to-r from-teal-500 to-cyan-500 p-3 rounded-xl">
//               <Heart className="h-8 w-8 text-white" />
//             </div>
//             <div>
//               <h1 className="text-2xl font-bold text-gray-800">SamHealth</h1>
//               <p className="text-sm text-teal-600">Hospital Registration Portal</p>
//             </div>
//           </div>
//           <h2 className="text-3xl font-bold text-gray-800 mb-2">Register Your Hospital</h2>
//           <p className="text-gray-600">Join our network and start processing insurance claims seamlessly</p>
//         </div>

//         {/* Progress Steps */}
//         {!submitSuccess && (
//           <div className="mb-8">
//             <div className="flex items-center justify-center">
//               {steps.map((step, index) => {
//                 const Icon = step.icon;
//                 const isActive = currentStep === step.id;
//                 const isCompleted = currentStep > step.id;

//                 return (
//                   <div key={step.id} className="flex items-center">
//                     {/* Step Circle */}
//                     <div className="flex flex-col items-center">
//                       <div className={`flex items-center justify-center w-16 h-16 rounded-full border-2 transition-all duration-300 ${
//                         isActive 
//                           ? 'bg-teal-500 border-teal-500 text-white shadow-lg' 
//                           : isCompleted
//                           ? 'bg-gray-100 border-gray-300 text-gray-400'
//                           : 'bg-gray-50 border-gray-200 text-gray-400'
//                       }`}>
//                         <Icon className="h-7 w-7" />
//                       </div>

//                       {/* Step Label */}
//                       <div className="mt-3 text-center max-w-24">
//                         <p className={`text-sm font-medium leading-tight ${
//                           isActive ? 'text-teal-600' : 'text-gray-500'
//                         }`}>
//                           {step.title}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Connector Line */}
//                     {index < steps.length - 1 && (
//                       <div className={`h-0.5 w-16 mx-4 transition-colors duration-300 ${
//                         isCompleted ? 'bg-teal-500' : 'bg-gray-200'
//                       }`} />
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* Form Content */}
//         <div className="card-medical mb-8">
//           {renderStepContent()}
//         </div>

//         {/* Navigation Buttons */}
//         {!submitSuccess && (
//           <div className="flex justify-between items-center">
//             <button
//               onClick={prevStep}
//               disabled={currentStep === 1}
//               className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
//                 currentStep === 1 
//                   ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
//                   : 'bg-white border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'
//               }`}
//             >
//               <ArrowLeft className="h-5 w-5" />
//               <span>Previous</span>
//             </button>

//             {/* Step indicator */}
//             <div className="text-sm text-gray-500 hidden md:block">
//               Step {currentStep} of {steps.length}
//             </div>

//             {currentStep < 6 ? (
//               <button
//                 onClick={nextStep}
//                 className="flex items-center space-x-2 btn-primary hover:shadow-lg transform hover:scale-105 transition-all duration-200"
//               >
//                 <span>Next</span>
//                 <ArrowRight className="h-5 w-5" />
//               </button>
//             ) : (
//               <button
//                 onClick={handleSubmit}
//                 disabled={loading}
//                 className="flex items-center space-x-2 btn-success disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-lg transform hover:scale-105 transition-all duration-200"
//               >
//                 {loading ? (
//                   <>
//                     <Loader className="h-5 w-5 animate-spin" />
//                     <span>Submitting...</span>
//                   </>
//                 ) : (
//                   <>
//                     <CheckCircle className="h-5 w-5" />
//                     <span>Submit Application</span>
//                   </>
//                 )}
//               </button>
//             )}
//           </div>
//         )}

//         {/* Help Section */}
//         <div className="mt-8 text-center">
//           <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-gray-200">
//             <h3 className="text-lg font-semibold text-gray-800 mb-2">Need Help?</h3>
//             <p className="text-sm text-gray-600 mb-4">
//               Our support team is here to assist you with the registration process
//             </p>
//             <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-6">
//               <a href="mailto:support@samriddhihealthcare.com" className="flex items-center text-teal-600 hover:text-teal-700 transition-colors">
//                 <Mail className="h-4 w-4 mr-2" />
//                 support@samriddhihealthcare.com
//               </a>
//               <a href="tel:+91-1800-XXX-XXXX" className="flex items-center text-teal-600 hover:text-teal-700 transition-colors">
//                 <Phone className="h-4 w-4 mr-2" />
//                 +91 1800-XXX-XXXX
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="mt-8 text-center">
//           <p className="text-xs text-gray-500">
//             © 2024 SamHealth. All rights reserved. | 
//             <a href="#" className="hover:text-teal-600 ml-1">Privacy Policy</a> | 
//             <a href="#" className="hover:text-teal-600 ml-1">Terms of Service</a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HospitalRegistration;







// Updated Hospital Registration with Lead Generator Referral

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Heart,
  Building,
  MapPin,
  Phone,
  Mail,
  Globe,
  Bed,
  Stethoscope,
  User,
  Upload,
  FileText,
  CreditCard,
  Lock,
  Eye,
  EyeOff,
  CheckCircle,
  AlertCircle,
  ArrowLeft,
  ArrowRight,
  X,
  Loader,
  Camera,
  Calendar,
  Search,
  ChevronDown,
  UserCheck
} from 'lucide-react';
import { registerHospital } from '../../services/hospitalService';
import { getApprovedLeadGenerators } from '../../services/leadGeneratorService';

const HospitalRegistration = () => {
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [applicationId, setApplicationId] = useState('');

  // Lead Generator referral states
  const [leadGenerators, setLeadGenerators] = useState([]);
  const [filteredLeadGenerators, setFilteredLeadGenerators] = useState([]);
  const [leadGenLoading, setLeadGenLoading] = useState(false);
  const [showLeadGenDropdown, setShowLeadGenDropdown] = useState(false);
  const [leadGenSearchTerm, setLeadGenSearchTerm] = useState('');
  const [selectedLeadGenerator, setSelectedLeadGenerator] = useState(null);
  const [referralFromUrl, setReferralFromUrl] = useState(null);

  // Form data state
  const [formData, setFormData] = useState({
    hospitalName: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    phone: '',
    email: '',
    website: '',
    numberOfBeds: '',
    facilities: [],
    specialities: [],
    mdName: '',
    mdContact: '',
    mdEmail: '',
    representativeName: '',
    designation: '',
    representativeEmail: '',
    representativePhone: '',
    mdAsRepresentative: false,
    accountEmail: '',
    password: '',
    confirmPassword: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    accountHolderName: '',
    registrationNumber: '',
    registrationValidityDate: '',
    hasNABH: false,
    hasQualityCouncil: false,
    pharmacyType: '',
    dlNumber: '',
    // Intervention fields
    pdcPercentage: '',
    pdcGstOption: '', // 'with' or 'without'
    fundingPercentage: '',
    fundingGstOption: '', // 'with' or 'without'
    // New field for lead generator referral
    referredBy: '', // Will store the lead generator ID
    referredByName: '', // Will store the lead generator name for display
    referredByCity: '', // Will store the lead generator city for display
  });

  // Documents state
  const [documents, setDocuments] = useState({
    registrationCert: null,
    nabhCert: null,
    qualityCouncilCert: null,
    pharmacyCert: null,
    facilitiesPhotos: [],
    medicalEstablishmentCert: null,
    authorizationLetter: null,
    cancelledCheque: null,
    panDocument: null,
    gstDocument: null,
    roomTariff: null,
    procedureTariff: null
  });

  // UI state
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [uploadProgress, setUploadProgress] = useState({});

  // Load lead generators on component mount
  useEffect(() => {
    loadLeadGenerators();
  }, []);

  // Handle referral parameter from URL
  useEffect(() => {
    const refParam = searchParams.get('ref');
    console.log('Referral parameter from URL:', refParam);
    if (refParam) {
      setReferralFromUrl(refParam);
      // Once lead generators are loaded, find and set the referred lead generator
      if (leadGenerators.length > 0) {
        const referredLeadGen = leadGenerators.find(lg =>
          lg.leadGeneratorId === refParam || lg.id === refParam
        );
        console.log('Num of lead generators:', leadGenerators);
        console.log('Referred Lead Generator:', referredLeadGen);
        if (referredLeadGen) {
          setSelectedLeadGenerator(referredLeadGen);
          setFormData(prev => ({
            ...prev,
            referredBy: referredLeadGen.id,
            referredByName: referredLeadGen.entityName,
            referredByCity: referredLeadGen.city
          }));
          setLeadGenSearchTerm(referredLeadGen.entityName);
        }
      }
    }
  }, [searchParams, leadGenerators]);

  // Filter lead generators based on search term
  useEffect(() => {
    if (leadGenSearchTerm.trim() === '') {
      setFilteredLeadGenerators(leadGenerators);
    } else {
      const filtered = leadGenerators.filter(lg =>
        lg.entityName.toLowerCase().includes(leadGenSearchTerm.toLowerCase()) ||
        lg.city.toLowerCase().includes(leadGenSearchTerm.toLowerCase()) ||
        lg.state.toLowerCase().includes(leadGenSearchTerm.toLowerCase())
      );
      setFilteredLeadGenerators(filtered);
    }
  }, [leadGenSearchTerm, leadGenerators]);

  // Load approved lead generators from Firestore
  const loadLeadGenerators = async () => {
    setLeadGenLoading(true);
    try {
      const result = await getApprovedLeadGenerators();
      if (result.success) {
        setLeadGenerators(result.leadGenerators);
        setFilteredLeadGenerators(result.leadGenerators);
      } else {
        console.error('Error loading lead generators:', result.error);
      }
    } catch (error) {
      console.error('Error loading lead generators:', error);
    } finally {
      setLeadGenLoading(false);
    }
  };

  // Handle lead generator selection
  const handleLeadGeneratorSelect = (leadGen) => {
    setSelectedLeadGenerator(leadGen);
    setFormData(prev => ({
      ...prev,
      referredBy: leadGen.id,
      referredByName: leadGen.entityName,
      referredByCity: leadGen.city
    }));
    setLeadGenSearchTerm(leadGen.entityName);
    setShowLeadGenDropdown(false);

    // Clear any errors
    if (errors.referredBy) {
      setErrors(prev => ({ ...prev, referredBy: '' }));
    }
  };

  // Clear lead generator selection
  const clearLeadGeneratorSelection = () => {
    setSelectedLeadGenerator(null);
    setFormData(prev => ({
      ...prev,
      referredBy: '',
      referredByName: '',
      referredByCity: ''
    }));
    setLeadGenSearchTerm('');
  };

  // Constants (keeping the existing ones)
  const steps = [
    { id: 1, title: 'Basic Information', icon: Building },
    { id: 2, title: 'Hospital Details', icon: Bed },
    { id: 3, title: 'Contact Information', icon: User },
    { id: 4, title: 'Documents', icon: FileText },
    { id: 5, title: 'Account & Banking', icon: CreditCard },
    { id: 6, title: 'Review & Submit', icon: CheckCircle }
  ];

  const facilities = [
    'Emergency Services', 'ICU', 'Operation Theatre', 'Laboratory', 'Radiology',
    'Pharmacy', 'Blood Bank', 'Dialysis', 'Physiotherapy', 'Ambulance Service',
    'Cafeteria', 'Parking', '24/7 Services', 'Oxygen Plant', 'CCTV Surveillance'
  ];

  const specialities = [
    'Cardiology', 'Orthopedics', 'Neurology', 'Pediatrics', 'Gynecology',
    'Oncology', 'Dermatology', 'ENT', 'Ophthalmology', 'Psychiatry',
    'General Surgery', 'Anesthesiology', 'Radiology', 'Pathology', 'Emergency Medicine',
    'Internal Medicine', 'Urology', 'Gastroenterology', 'Pulmonology', 'Nephrology'
  ];

  const states = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
    'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
    'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  ];

  // Render Lead Generator Referral Dropdown
  const renderLeadGeneratorReferral = () => (
    <div className="relative">
      {/* Referral Link Notification */}
      {referralFromUrl && selectedLeadGenerator && (
        <div className="mb-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start">
            <UserCheck className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-blue-900 mb-1">
                Referred by Lead Generator
              </h4>
              <p className="text-sm text-blue-800">
                You were referred by <strong>{selectedLeadGenerator.entityName}</strong> from {selectedLeadGenerator.city}, {selectedLeadGenerator.state}.
                They will receive credit for your successful registration.
              </p>
            </div>
          </div>
        </div>
      )}

      <label className="form-label">
        Referred by Lead Generator (Optional)
        <span className="text-sm text-gray-500 font-normal ml-2">- Select if referred by any organization</span>
      </label>

      <div className="relative">
        <div className="relative">
          <input
            type="text"
            value={leadGenSearchTerm}
            disabled
            onChange={(e) => {
              setLeadGenSearchTerm(e.target.value);
              setShowLeadGenDropdown(true);
            }}
            onFocus={() => setShowLeadGenDropdown(true)}
            className={`input-field pr-20 ${errors.referredBy ? 'input-error' : ''}`}
            placeholder="Search lead generator by name or city..."
          />

          <div className="absolute inset-y-0 right-0 flex items-center">
            {/* {formData.referredBy && (
              <button
                type="button"
                onClick={clearLeadGeneratorSelection}
                className="p-1 mr-1 text-gray-400 hover:text-red-500 rounded"
                title="Clear selection"
              >
                <X className="h-4 w-4" />
              </button>
            )} */}

            <div className="p-2">
              {leadGenLoading ? (
                <Loader className="h-4 w-4 animate-spin text-gray-400" />
              ) : (
                <div className="flex items-center space-x-1">
                  <Search className="h-4 w-4 text-gray-400" />
                  <ChevronDown className="h-4 w-4 text-gray-400" />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Dropdown */}
        {showLeadGenDropdown && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
            {filteredLeadGenerators.length === 0 ? (
              <div className="p-4 text-center">
                {leadGenLoading ? (
                  <div className="flex items-center justify-center space-x-2">
                    <Loader className="h-4 w-4 animate-spin text-gray-400" />
                    <span className="text-sm text-gray-500">Loading lead generators...</span>
                  </div>
                ) : leadGenSearchTerm.trim() === '' ? (
                  <span className="text-sm text-gray-500">Start typing to search lead generators</span>
                ) : (
                  <span className="text-sm text-gray-500">No lead generators found</span>
                )}
              </div>
            ) : (
              <div className="py-1">
                {filteredLeadGenerators.map((leadGen) => (
                  <button
                    key={leadGen.id}
                    type="button"
                    onClick={() => handleLeadGeneratorSelect(leadGen)}
                    className="w-full text-left px-4 py-3 hover:bg-gray-50 focus:bg-gray-50 border-b border-gray-100 last:border-b-0"
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-medium text-gray-900">{leadGen.entityName}</p>
                        <p className="text-sm text-gray-600">{leadGen.city}, {leadGen.state}</p>
                        {leadGen.servicesRequired && leadGen.servicesRequired.length > 0 && (
                          <p className="text-xs text-blue-600 mt-1">
                            Services: {leadGen.servicesRequired.slice(0, 2).join(', ')}
                            {leadGen.servicesRequired.length > 2 && ` +${leadGen.servicesRequired.length - 2} more`}
                          </p>
                        )}
                      </div>
                      {formData.referredBy === leadGen.id && (
                        <CheckCircle className="h-4 w-4 text-green-500" />
                      )}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Selected Lead Generator Display */}
      {formData.referredBy && (
        <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center space-x-2">
            <UserCheck className="h-4 w-4 text-green-600" />
            <div>
              <p className="text-sm font-medium text-green-800">
                Referred by: {formData.referredByName}
              </p>
              <p className="text-xs text-green-600">
                Location: {formData.referredByCity}
              </p>
            </div>
          </div>
        </div>
      )}

      {errors.referredBy && <p className="form-error">{errors.referredBy}</p>}

      {/* Click outside to close dropdown */}
      {showLeadGenDropdown && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowLeadGenDropdown(false)}
        />
      )}
    </div>
  );

  // Event handlers (keeping existing ones)
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => {
      const updated = { ...prev, [name]: newValue };

      // Auto-fill representative data if MD is representative
      if (name === 'mdAsRepresentative' && checked) {
        updated.representativeName = updated.mdName;
        updated.representativeEmail = updated.mdEmail;
        updated.representativePhone = updated.mdContact;
        updated.designation = 'Managing Director';
      } else if (name === 'mdAsRepresentative' && !checked) {
        updated.representativeName = '';
        updated.representativeEmail = '';
        updated.representativePhone = '';
        updated.designation = '';
      }

      // Auto-fill when MD details change and MD is representative
      if (updated.mdAsRepresentative) {
        if (name === 'mdName') updated.representativeName = value;
        if (name === 'mdEmail') updated.representativeEmail = value;
        if (name === 'mdContact') updated.representativePhone = value;
      }

      return updated;
    });

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // Keep all existing methods unchanged...
  const handleMultiSelect = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].includes(value)
        ? prev[field].filter(item => item !== value)
        : [...prev[field], value]
    }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Validation functions (keeping existing ones, no changes needed)
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^[6-9]\d{9}$/.test(phone.replace(/\s+/g, ''));
  const validatePincode = (pincode) => /^\d{6}$/.test(pincode);
  const validateIFSC = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      case 1: // Basic Information
        if (!formData.hospitalName.trim()) newErrors.hospitalName = 'Hospital name is required';
        if (!formData.address.trim()) newErrors.address = 'Address is required';
        if (!formData.city.trim()) newErrors.city = 'City is required';
        if (!formData.state) newErrors.state = 'State is required';
        if (!formData.pincode.trim()) newErrors.pincode = 'Pincode is required';
        else if (!validatePincode(formData.pincode)) newErrors.pincode = 'Invalid pincode format';
        if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
        else if (!validatePhone(formData.phone)) newErrors.phone = 'Invalid phone number';
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        else if (!validateEmail(formData.email)) newErrors.email = 'Invalid email format';
        if (!formData.registrationNumber.trim()) newErrors.registrationNumber = 'Registration number is required';
        if (!formData.registrationValidityDate) newErrors.registrationValidityDate = 'Registration validity date is required';
        // Note: referredBy is optional, so no validation needed
        break;

      // Keep all other validation cases unchanged...
      case 2: // Hospital Details
        if (!formData.numberOfBeds) newErrors.numberOfBeds = 'Number of beds is required';
        else if (parseInt(formData.numberOfBeds) < 1) newErrors.numberOfBeds = 'Must have at least 1 bed';
        if (formData.facilities.length === 0) newErrors.facilities = 'Select at least one facility';
        if (formData.specialities.length === 0) newErrors.specialities = 'Select at least one speciality';
        if (!formData.pharmacyType) newErrors.pharmacyType = 'Please specify pharmacy type';
        if (formData.pharmacyType === 'inhouse' && !formData.dlNumber.trim()) {
          newErrors.dlNumber = 'DL number is required for in-house pharmacy';
        }
        break;

      case 3: // Contact Information
        if (!formData.mdName.trim()) newErrors.mdName = 'MD name is required';
        if (!formData.mdContact.trim()) newErrors.mdContact = 'MD contact is required';
        else if (!validatePhone(formData.mdContact)) newErrors.mdContact = 'Invalid MD contact number';
        if (formData.mdEmail && !validateEmail(formData.mdEmail)) newErrors.mdEmail = 'Invalid MD email format';

        if (!formData.mdAsRepresentative) {
          if (!formData.representativeName.trim()) newErrors.representativeName = 'Representative name is required';
          if (!formData.designation.trim()) newErrors.designation = 'Designation is required';
          if (!formData.representativeEmail.trim()) newErrors.representativeEmail = 'Representative email is required';
          else if (!validateEmail(formData.representativeEmail)) newErrors.representativeEmail = 'Invalid email format';
          if (!formData.representativePhone.trim()) newErrors.representativePhone = 'Representative phone is required';
          else if (!validatePhone(formData.representativePhone)) newErrors.representativePhone = 'Invalid phone number';
        }
        break;

      case 4: // Documents
        if (!documents.registrationCert) newErrors.registrationCert = 'Hospital Registration Certificate is required';
        if (formData.hasNABH && !documents.nabhCert) newErrors.nabhCert = 'NABH Certificate is required';
        if (formData.hasQualityCouncil && !documents.qualityCouncilCert) newErrors.qualityCouncilCert = 'Quality Council Certificate is required';
        if (formData.pharmacyType === 'inhouse' && !documents.pharmacyCert) newErrors.pharmacyCert = 'Pharmacy Certificate is required';
        if (!documents.facilitiesPhotos || documents.facilitiesPhotos.length < 4) {
          newErrors.facilitiesPhotos = 'Minimum 4 facility photos are required';
        }
        break;

      case 5: // Account & Banking
        if (!formData.accountEmail.trim()) newErrors.accountEmail = 'Account email is required';
        else if (!validateEmail(formData.accountEmail)) newErrors.accountEmail = 'Invalid email format';
        if (!formData.password) newErrors.password = 'Password is required';
        else if (formData.password.length < 8) newErrors.password = 'Password must be at least 8 characters';
        if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm password is required';
        else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        if (!formData.bankName.trim()) newErrors.bankName = 'Bank name is required';
        if (!formData.accountNumber.trim()) newErrors.accountNumber = 'Account number is required';
        if (!formData.ifscCode.trim()) newErrors.ifscCode = 'IFSC code is required';
        else if (!validateIFSC(formData.ifscCode)) newErrors.ifscCode = 'Invalid IFSC code format';
        if (!formData.accountHolderName.trim()) newErrors.accountHolderName = 'Account holder name is required';
        if (!formData.pdcPercentage.trim()) newErrors.pdcPercentage = 'PDC percentage is required';
        else if (isNaN(formData.pdcPercentage) || parseFloat(formData.pdcPercentage) < 0 || parseFloat(formData.pdcPercentage) > 100) {
          newErrors.pdcPercentage = 'PDC percentage must be a valid number between 0 and 100';
        }
        if (!formData.pdcGstOption) newErrors.pdcGstOption = 'Please specify if PDC percentage is with or without GST';
        if (!formData.fundingPercentage.trim()) newErrors.fundingPercentage = 'Funding percentage is required';
        else if (isNaN(formData.fundingPercentage) || parseFloat(formData.fundingPercentage) < 0 || parseFloat(formData.fundingPercentage) > 100) {
          newErrors.fundingPercentage = 'Funding percentage must be a valid number between 0 and 100';
        }
        if (!formData.fundingGstOption) newErrors.fundingGstOption = 'Please specify if Funding percentage is with or without GST';
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Keep all existing navigation and submit handlers unchanged...
  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, 6));
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const handleSubmit = async () => {
    if (!validateStep(5)) return;

    setLoading(true);
    try {
      const documentsToUpload = {};

      // Handle regular documents and facilities photos separately
      Object.entries(documents).forEach(([key, file]) => {
        if (file) {
          if (key === 'facilitiesPhotos' && Array.isArray(file)) {
            // Handle facilities photos as individual files with indexed keys
            file.forEach((fileObj, index) => {
              documentsToUpload[`facilitiesPhoto_${index}`] = fileObj.file;
            });
          } else {
            documentsToUpload[key] = file;
          }
        }
      });

      console.log('Documents being sent:', documentsToUpload); // Debug log
      console.log('Form data with referral:', formData); // Debug log

      const result = await registerHospital(formData, documentsToUpload);

      if (result.success) {
        setApplicationId(result.applicationId);
        setSubmitSuccess(true);
      } else {
        setErrors({ submit: result.error });
      }
    } catch (error) {
      console.error('Registration error:', error);
      setErrors({ submit: 'Registration failed. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  // Keep all existing render methods...
  const renderFormField = (name, label, type = 'text', required = true, placeholder = '', options = {}) => (
    <div>
      <label className="form-label">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {type === 'select' ? (
        <select
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          className={`input-field ${errors[name] ? 'input-error' : ''}`}
        >
          <option value="">{placeholder}</option>
          {options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          className={`input-field ${errors[name] ? 'input-error' : ''}`}
          placeholder={placeholder}
          rows={options.rows || 3}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          className={`input-field ${errors[name] ? 'input-error' : ''}`}
          placeholder={placeholder}
          min={options.min}
          max={options.max}
          step={options.step}
          disabled={options.disabled}
        />
      )}
      {errors[name] && <p className="form-error">{errors[name]}</p>}
    </div>
  );

  // Keep all other render methods unchanged and update the Basic Information step
  const renderStepContent = () => {
    if (submitSuccess) {
      return (
        <div className="text-center space-y-6">
          <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Registration Submitted Successfully!</h3>
            <p className="text-gray-600 mb-4">Your hospital registration has been submitted for review.</p>
            <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
              <p className="text-sm text-primary-800"><strong>Application ID:</strong> {applicationId}</p>
              <p className="text-sm text-primary-600 mt-2">
                Please save this application ID for future reference. You will receive an email confirmation
                and further updates on your registered email address.
              </p>
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm text-gray-600"><strong>What's Next?</strong></p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Our team will review your application within 2-3 business days</li>
              <li>• You'll receive an email notification once approved</li>
              <li>• After approval, you can login with your account credentials</li>
              <li>• Start submitting insurance applications for your patients</li>
            </ul>
          </div>

          <button onClick={() => window.location.href = '/'} className="btn-primary">
            Return to Homepage
          </button>
        </div>
      );
    }

    switch (currentStep) {
      case 1: // Basic Information - UPDATED
        return (
          <div className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              {renderFormField('hospitalName', 'Hospital Name', 'text', true, 'Enter hospital name')}
              {renderFormField('phone', 'Phone Number', 'tel', true, '+91 XXXXX XXXXX')}
            </div>

            {/* Lead Generator Referral - NEW */}
            {renderLeadGeneratorReferral()}

            {renderFormField('address', 'Address', 'textarea', true, 'Enter complete address', { rows: 3 })}
            <div className="grid md:grid-cols-3 gap-6">
              {renderFormField('city', 'City', 'text', true, 'Enter city')}
              {renderFormField('state', 'State', 'select', true, 'Select State', states)}
              {renderFormField('pincode', 'Pincode', 'text', true, 'XXXXXX')}
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {renderFormField('email', 'Email Address', 'email', true, 'hospital@example.com')}
              {renderFormField('website', 'Website', 'url', false, 'https://www.hospital.com')}
            </div>
            <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
              <h4 className="font-semibold text-blue-800 mb-2">Registration Details</h4>
              <p className="text-sm text-blue-600 mb-3">Hospital registration certificate details</p>
              <div className="grid md:grid-cols-2 gap-6">
                {renderFormField('registrationNumber', 'Registration Number', 'text', true, 'Enter registration number')}
                {renderFormField('registrationValidityDate', 'Registration Validity Date', 'date', true)}
              </div>
            </div>
          </div>
        );

      // Keep all other cases unchanged...
      case 6: // Review & Submit - UPDATED to show referral info
        return (
          <div className="space-y-6">
            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start space-x-3">
                <CheckCircle className="h-5 w-5 text-green-600 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-green-800">Review Your Information</h4>
                  <p className="text-sm text-green-700 mt-1">
                    Please review all information before submitting your application
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {/* Hospital Information - UPDATED */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <Building className="h-5 w-5 mr-2 text-primary-500" />
                  Hospital Information
                </h4>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div><span className="font-medium">Name:</span> {formData.hospitalName}</div>
                  <div><span className="font-medium">Phone:</span> {formData.phone}</div>
                  <div><span className="font-medium">Email:</span> {formData.email}</div>
                  <div><span className="font-medium">Website:</span> {formData.website || 'Not provided'}</div>
                  <div><span className="font-medium">Registration No:</span> {formData.registrationNumber}</div>
                  <div><span className="font-medium">Validity Date:</span> {formData.registrationValidityDate}</div>
                  {formData.referredBy && (
                    <>
                      <div className="md:col-span-2 bg-green-50 p-2 rounded">
                        <span className="font-medium">Referred by:</span> {formData.referredByName}
                        {formData.referredByCity && <span className="text-green-600 ml-2">({formData.referredByCity})</span>}
                      </div>
                    </>
                  )}
                  <div className="md:col-span-2"><span className="font-medium">Address:</span> {formData.address}, {formData.city}, {formData.state} - {formData.pincode}</div>
                </div>
              </div>

              {/* Hospital Details */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <Bed className="h-5 w-5 mr-2 text-primary-500" />
                  Hospital Details
                </h4>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div><span className="font-medium">Number of Beds:</span> {formData.numberOfBeds}</div>
                  <div><span className="font-medium">Pharmacy Type:</span> {formData.pharmacyType === 'inhouse' ? 'In-house' : 'Outsourced'}</div>
                  {formData.pharmacyType === 'inhouse' && (
                    <div><span className="font-medium">DL Number:</span> {formData.dlNumber}</div>
                  )}
                  <div className="md:col-span-2">
                    <span className="font-medium">Facilities:</span> {formData.facilities.join(', ')}
                  </div>
                  <div className="md:col-span-2">
                    <span className="font-medium">Specialities:</span> {formData.specialities.join(', ')}
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <User className="h-5 w-5 mr-2 text-primary-500" />
                  Contact Information
                </h4>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div><span className="font-medium">MD Name:</span> {formData.mdName}</div>
                  <div><span className="font-medium">MD Contact:</span> {formData.mdContact}</div>
                  <div><span className="font-medium">MD Email:</span> {formData.mdEmail || 'Not provided'}</div>
                  <div><span className="font-medium">Representative:</span> {formData.mdAsRepresentative ? 'Same as MD' : formData.representativeName}</div>
                  {!formData.mdAsRepresentative && (
                    <>
                      <div><span className="font-medium">Designation:</span> {formData.designation}</div>
                      <div><span className="font-medium">Rep. Email:</span> {formData.representativeEmail}</div>
                      <div><span className="font-medium">Rep. Phone:</span> {formData.representativePhone}</div>
                    </>
                  )}
                </div>
              </div>

              {/* Documents */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <FileText className="h-5 w-5 mr-2 text-primary-500" />
                  Documents Uploaded
                </h4>
                <div className="grid md:grid-cols-2 gap-2 text-sm">
                  {Object.entries(documents).map(([key, file]) => {
                    if (key === 'facilitiesPhotos' && file && file.length > 0) {
                      return (
                        <div key={key} className="flex items-center space-x-2 md:col-span-2">
                          <CheckCircle className="h-4 w-4 text-green-500" />
                          <span>Facility Photos ({file.length} photos uploaded)</span>
                        </div>
                      );
                    } else if (file && key !== 'facilitiesPhotos') {
                      return (
                        <div key={key} className="flex items-center space-x-2">
                          <CheckCircle className="h-4 w-4 text-green-500" />
                          <span>{file.name}</span>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>

              {/* Account & Bank Details */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <CreditCard className="h-5 w-5 mr-2 text-primary-500" />
                  Account & Bank Details
                </h4>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div><span className="font-medium">Account Email:</span> {formData.accountEmail}</div>
                  <div><span className="font-medium">Bank Name:</span> {formData.bankName}</div>
                  <div><span className="font-medium">Account Holder:</span> {formData.accountHolderName}</div>
                  <div><span className="font-medium">IFSC Code:</span> {formData.ifscCode}</div>
                </div>
              </div>

              {/* Intervention Details */}
              <div className="card">
                <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <CreditCard className="h-5 w-5 mr-2 text-orange-500" />
                  Intervention Details
                </h4>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div>
                    <span className="font-medium">PDC Percentage:</span> {formData.pdcPercentage}%
                    <span className="text-gray-600 ml-2">
                      ({formData.pdcGstOption === 'with' ? 'Including GST' : formData.pdcGstOption === 'without' ? 'Excluding GST' : 'GST not specified'})
                    </span>
                  </div>
                  <div>
                    <span className="font-medium">Funding Percentage:</span> {formData.fundingPercentage}%
                    <span className="text-gray-600 ml-2">
                      ({formData.fundingGstOption === 'with' ? 'Including GST' : formData.fundingGstOption === 'without' ? 'Excluding GST' : 'GST not specified'})
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Error Message */}
            {errors.submit && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <AlertCircle className="h-5 w-5 text-red-600" />
                  <p className="text-red-700">{errors.submit}</p>
                </div>
              </div>
            )}

            {/* Terms & Conditions */}
            <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
              <div className="flex items-start space-x-3">
                <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-amber-800">Terms & Conditions</h4>
                  <p className="text-sm text-amber-700 mt-1">
                    By submitting this application, you agree to our terms and conditions. Your application will be reviewed by our team and you will be notified of the approval status via email.
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      case 2: // Hospital Details
        return (
          <div className="space-y-6">
            {renderFormField('numberOfBeds', 'Number of Beds', 'number', true, 'Enter number of beds', { min: 1 })}
            {renderMultiSelect('facilities', 'Facilities Available', facilities)}
            {renderMultiSelect('specialities', 'Medical Specialities', specialities)}

            <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
              <h4 className="font-semibold text-purple-800 mb-2">Pharmacy Information</h4>
              <p className="text-sm text-purple-600 mb-3">Please specify your pharmacy setup</p>

              <div className="space-y-4">
                <div>
                  <label className="form-label">
                    Pharmacy Type <span className="text-red-500">*</span>
                  </label>
                  <div className="space-y-2">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="pharmacyType"
                        value="inhouse"
                        checked={formData.pharmacyType === 'inhouse'}
                        onChange={handleInputChange}
                        className="text-purple-500 focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-700">In-house Pharmacy</span>
                    </label>
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        name="pharmacyType"
                        value="outsourced"
                        checked={formData.pharmacyType === 'outsourced'}
                        onChange={handleInputChange}
                        className="text-purple-500 focus:ring-purple-500"
                      />
                      <span className="text-sm text-gray-700">Outsourced Pharmacy</span>
                    </label>
                  </div>
                  {errors.pharmacyType && <p className="form-error">{errors.pharmacyType}</p>}
                </div>

                {formData.pharmacyType === 'inhouse' && (
                  <div>
                    {renderFormField('dlNumber', 'Drug License (DL) Number', 'text', true, 'Enter DL number')}
                  </div>
                )}
              </div>
            </div>
          </div>
        );

      case 3: // Contact Information
        return (
          <div className="space-y-6">
            <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-200">
              <h4 className="font-semibold text-secondary-800 mb-2">Managing Director (MD)</h4>
              <p className="text-sm text-secondary-600">Hospital's managing director information</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {renderFormField('mdName', 'MD Name', 'text', true, 'Dr. Full Name')}
              {renderFormField('mdContact', 'MD Contact', 'tel', true, '+91 XXXXX XXXXX')}
            </div>
            {renderFormField('mdEmail', 'MD Email', 'email', false, 'md@hospital.com')}

            <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
              <label className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="mdAsRepresentative"
                  checked={formData.mdAsRepresentative}
                  onChange={handleInputChange}
                  className="rounded border-amber-300 text-amber-500 focus:ring-amber-500"
                />
                <div>
                  <span className="font-medium text-amber-800">MD will act as Hospital Representative</span>
                  <p className="text-sm text-amber-600">Check this if MD will be the primary contact for this application</p>
                </div>
              </label>
            </div>

            {!formData.mdAsRepresentative && (
              <>
                <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
                  <h4 className="font-semibold text-primary-800 mb-2">Hospital Representative</h4>
                  <p className="text-sm text-primary-600">Primary contact person for this application</p>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                  {renderFormField('representativeName', 'Representative Name', 'text', true, 'Full name')}
                  {renderFormField('designation', 'Designation', 'text', true, 'e.g., Administrator, Manager')}
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                  {renderFormField('representativeEmail', 'Representative Email', 'email', true, 'representative@hospital.com')}
                  {renderFormField('representativePhone', 'Representative Phone', 'tel', true, '+91 XXXXX XXXXX')}
                </div>
              </>
            )}
          </div>
        );

      case 4: // Documents
        return (
          <div className="space-y-6">
            <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
              <div className="flex items-start space-x-3">
                <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-amber-800">Document Requirements</h4>
                  <p className="text-sm text-amber-700 mt-1">
                    All documents must be clear, valid, and in PDF, JPEG, or PNG format (max 5MB each)
                  </p>
                </div>
              </div>
            </div>

            {/* Quality Certifications */}
            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <h4 className="font-semibold text-green-800 mb-3">Quality Certifications</h4>
              <div className="space-y-3">
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    name="hasNABH"
                    checked={formData.hasNABH}
                    onChange={handleInputChange}
                    className="rounded border-green-300 text-green-500 focus:ring-green-500"
                  />
                  <span className="text-green-700">Hospital has NABH Certificate</span>
                </label>
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    name="hasQualityCouncil"
                    checked={formData.hasQualityCouncil}
                    onChange={handleInputChange}
                    className="rounded border-green-300 text-green-500 focus:ring-green-500"
                  />
                  <span className="text-green-700">Hospital has Quality Council of India Certificate</span>
                </label>
              </div>
            </div>

            <div className="grid gap-6">
              {documentConfig.map(renderDocumentUpload)}
            </div>
          </div>
        );

      case 5: // Account & Banking
        return (
          <div className="space-y-6">
            <div className="bg-primary-50 rounded-lg p-4 border border-primary-200">
              <h4 className="font-semibold text-primary-800 mb-2">Account Information</h4>
              <p className="text-sm text-primary-600">These credentials will be used to login after approval</p>
            </div>
            {renderFormField('accountEmail', 'Account Email', 'email', true, 'login@hospital.com')}
            <div className="grid md:grid-cols-2 gap-6">
              {renderPasswordField('password', 'Password', showPassword, setShowPassword)}
              {renderPasswordField('confirmPassword', 'Confirm Password', showConfirmPassword, setShowConfirmPassword)}
            </div>

            <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-200">
              <h4 className="font-semibold text-secondary-800 mb-2">Bank Account Details</h4>
              <p className="text-sm text-secondary-600">For reimbursement and payment processing</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {renderFormField('bankName', 'Bank Name', 'text', true, 'Enter bank name')}
              {renderFormField('accountHolderName', 'Account Holder Name', 'text', true, 'Account holder name')}
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {renderFormField('accountNumber', 'Account Number', 'text', true, 'Enter account number')}
              {renderFormField('ifscCode', 'IFSC Code', 'text', true, 'IFSC Code')}
            </div>

            <div className="bg-orange-50 rounded-lg p-4 border border-orange-200">
              <h4 className="font-semibold text-orange-800 mb-2">Intervention</h4>
              <p className="text-sm text-orange-600">Specify the percentage for PDC and Funding requirements</p>
            </div>

            <div className="space-y-6">
              {/* PDC Section */}
              <div className="bg-white rounded-lg p-4 border border-gray-200">
                <h5 className="font-medium text-gray-800 mb-3">PDC (Post Dated Cheque) Details</h5>

                <div className="space-y-4">
                  <div>
                    <label className="form-label">
                      GST Inclusion for PDC <span className="text-red-500">*</span>
                    </label>
                    <div className="flex space-x-4 mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="pdcGstOption"
                          value="with"
                          checked={formData.pdcGstOption === 'with'}
                          onChange={handleInputChange}
                          className="text-orange-500 focus:ring-orange-500"
                        />
                        <span className="text-sm text-gray-700">Including GST</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="pdcGstOption"
                          value="without"
                          checked={formData.pdcGstOption === 'without'}
                          onChange={handleInputChange}
                          className="text-orange-500 focus:ring-orange-500"
                        />
                        <span className="text-sm text-gray-700">Excluding GST</span>
                      </label>
                    </div>
                    {errors.pdcGstOption && <p className="form-error">{errors.pdcGstOption}</p>}
                  </div>

                  {renderFormField('pdcPercentage', 'PDC Percentage', 'number', true, 'Enter PDC percentage (0-100)', { min: 0, max: 100, step: 0.01 })}
                </div>
              </div>

              {/* Funding Section */}
              <div className="bg-white rounded-lg p-4 border border-gray-200">
                <h5 className="font-medium text-gray-800 mb-3">Funding Details</h5>

                <div className="space-y-4">
                  <div>
                    <label className="form-label">
                      GST Inclusion for Funding <span className="text-red-500">*</span>
                    </label>
                    <div className="flex space-x-4 mt-2">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="fundingGstOption"
                          value="with"
                          checked={formData.fundingGstOption === 'with'}
                          onChange={handleInputChange}
                          className="text-orange-500 focus:ring-orange-500"
                        />
                        <span className="text-sm text-gray-700">Including GST</span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="fundingGstOption"
                          value="without"
                          checked={formData.fundingGstOption === 'without'}
                          onChange={handleInputChange}
                          className="text-orange-500 focus:ring-orange-500"
                        />
                        <span className="text-sm text-gray-700">Excluding GST</span>
                      </label>
                    </div>
                    {errors.fundingGstOption && <p className="form-error">{errors.fundingGstOption}</p>}
                  </div>

                  {renderFormField('fundingPercentage', 'Funding Percentage', 'number', true, 'Enter funding percentage (0-100)', { min: 0, max: 100, step: 0.01 })}
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  // Keep all existing helper methods (renderMultiSelect, renderPasswordField, etc.)
  const renderMultiSelect = (field, label, options, required = true) => (
    <div>
      <label className="form-label">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <p className="form-help mb-3">Select all that apply</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-48 overflow-y-auto">
        {options.map(option => (
          <label key={option} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={formData[field].includes(option)}
              onChange={() => handleMultiSelect(field, option)}
              className="rounded border-gray-300 text-primary-500 focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">{option}</span>
          </label>
        ))}
      </div>
      {errors[field] && <p className="form-error">{errors[field]}</p>}
    </div>
  );

  const renderPasswordField = (name, label, showState, setShowState) => (
    <div>
      <label className="form-label">{label} <span className="text-red-500">*</span></label>
      <div className="relative">
        <input
          type={showState ? 'text' : 'password'}
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          className={`input-field pr-10 ${errors[name] ? 'input-error' : ''}`}
          placeholder={`Enter ${label.toLowerCase()}`}
        />
        <button
          type="button"
          onClick={() => setShowState(!showState)}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          {showState ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
        </button>
      </div>
      {errors[name] && <p className="form-error">{errors[name]}</p>}
    </div>
  );

  // Keep all existing file upload handlers and document configuration
  const documentConfig = [
    { key: 'registrationCert', label: 'Hospital Registration Certificate (as per Medical Establishment Act)', required: true },
    { key: 'nabhCert', label: 'NABH Certificate', required: false, conditional: 'hasNABH' },
    { key: 'qualityCouncilCert', label: 'Quality Council of India Certificate', required: false, conditional: 'hasQualityCouncil' },
    { key: 'pharmacyCert', label: 'Pharmacy Certificate', required: false, conditional: 'pharmacyType' },
    { key: 'facilitiesPhotos', label: 'Facilities Photos (Infrastructure)', required: true, multiple: true },
    { key: 'medicalEstablishmentCert', label: 'Medical Establishment Act Certificate', required: false },
    { key: 'authorizationLetter', label: 'Authorization Letter', required: false },
    { key: 'cancelledCheque', label: 'Cancelled Cheque', required: false },
    { key: 'panDocument', label: 'Hospital PAN Document', required: false },
    { key: 'gstDocument', label: 'GST Certificate', required: false },
    { key: 'roomTariff', label: 'Hospital Room Tariff Document', required: false },
    { key: 'procedureTariff', label: 'Procedure Tariff Document', required: false }
  ];

  const handleFileUpload = (docType, file, isMultiple = false) => {
    if (!file) return;

    // Validate file
    const maxSize = 100 * 1024 * 1024; // 100MB
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

    if (file.size > maxSize) {
      setErrors(prev => ({ ...prev, [docType]: 'File size should be less than 100MB' }));
      return;
    }

    // if (!allowedTypes.includes(file.type)) {
    //   setErrors(prev => ({ ...prev, [docType]: 'Please upload PDF, JPEG, or PNG files only' }));
    //   return;
    // }

    if (isMultiple) {
      setDocuments(prev => {
        const currentPhotos = prev[docType] || [];
        if (currentPhotos.length >= 8) {
          setErrors(prevErr => ({ ...prevErr, [docType]: 'Maximum 8 photos allowed' }));
          return prev;
        }

        // Create a structured object for multiple files
        const fileObj = {
          file: file,
          name: file.name,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified,
          id: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        };

        return { ...prev, [docType]: [...currentPhotos, fileObj] };
      });
    } else {
      setDocuments(prev => ({ ...prev, [docType]: file }));
    }

    setErrors(prev => ({ ...prev, [docType]: '' }));

    // Simulate upload progress
    const progressKey = isMultiple ? `${docType}_${Date.now()}` : docType;
    setUploadProgress(prev => ({ ...prev, [progressKey]: 0 }));
    const interval = setInterval(() => {
      setUploadProgress(prev => {
        const progress = (prev[progressKey] || 0) + 10;
        if (progress >= 100) {
          clearInterval(interval);
          return { ...prev, [progressKey]: 100 };
        }
        return { ...prev, [progressKey]: progress };
      });
    }, 100);
  };

  const removeFile = (docType, index = null) => {
    if (index !== null) {
      // Remove specific photo
      setDocuments(prev => ({
        ...prev,
        [docType]: prev[docType].filter((_, i) => i !== index)
      }));
    } else {
      setDocuments(prev => ({ ...prev, [docType]: null }));
    }
    setUploadProgress(prev => ({ ...prev, [docType]: 0 }));
  };

  const renderDocumentUpload = (doc) => {
    if (doc.conditional) {
      if (doc.conditional === 'hasNABH' && !formData.hasNABH) return null;
      if (doc.conditional === 'hasQualityCouncil' && !formData.hasQualityCouncil) return null;
      if (doc.conditional === 'pharmacyType' && formData.pharmacyType !== 'inhouse') return null;
    }

    if (doc.multiple) {
      return (
        <div key={doc.key} className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center justify-between mb-3">
            <h4 className="font-medium text-gray-800">
              {doc.label} {doc.required && <span className="text-red-500">*</span>}
            </h4>
          </div>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">Upload 4-8 photos of your hospital facilities</p>
            <div className="dropzone p-6 text-center">
              <Camera className="h-8 w-8 text-gray-400 mx-auto mb-2" />
              <p className="text-sm text-gray-600 mb-2">Click to upload facility photos</p>
              <p className="text-xs text-gray-500">{doc.label?.includes("Tariff") ? "JPEG, PNG, XLS up to 100MB each" : "JPEG, PNG up to 100MB each"}</p>
              <input
                type="file"
                accept={doc.label?.toLowerCase()?.includes("tariff") ? ".jpg,.jpeg,.png,.xlsx,.xls" : ".jpg,.jpeg,.png"}
                multiple
                onChange={(e) => Array.from(e.target.files).forEach(file => handleFileUpload(doc.key, file, true))}
                className="hidden"
                id={doc.key}
              />
              <label htmlFor={doc.key} className="btn-primary mt-3 cursor-pointer">
                <Upload className="h-4 w-4 mr-2" />
                Choose Photos
              </label>
            </div>
          </div>

          {documents[doc.key] && documents[doc.key].length > 0 && (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {documents[doc.key].map((fileObj, index) => (
                <div key={fileObj.id || index} className="relative bg-green-50 border border-green-200 rounded-lg p-3">
                  <button
                    onClick={() => removeFile(doc.key, index)}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                  >
                    <X className="h-3 w-3" />
                  </button>
                  <div className="flex items-center space-x-2">
                    <Camera className="h-4 w-4 text-green-600" />
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium text-green-800 truncate">{fileObj.name}</p>
                      <p className="text-xs text-green-600">{(fileObj.size / 1024 / 1024).toFixed(2)} MB</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {documents[doc.key] && (
            <p className="text-sm text-green-600 mt-2">
              {documents[doc.key].length} photo(s) uploaded (minimum 4 required)
            </p>
          )}

          {errors[doc.key] && <p className="form-error mt-2">{errors[doc.key]}</p>}
        </div>
      );
    }

    return (
      <div key={doc.key} className="border border-gray-200 rounded-lg p-4">
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-medium text-gray-800">
            {doc.label} {doc.required && <span className="text-red-500">*</span>}
          </h4>
          {documents[doc.key] && (
            <button onClick={() => removeFile(doc.key)} className="text-red-500 hover:text-red-700 p-1">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>

        {!documents[doc.key] ? (
          <div className="dropzone p-6 text-center">
            <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" />
            <p className="text-sm text-gray-600 mb-2">Click to upload or drag and drop</p>
            <p className="text-xs text-gray-500">{doc.label?.toLowerCase()?.includes("tariff") ? "PDF, JPEG, PNG, Excel up to 100MB" : "PDF, JPEG, PNG up to 100MB"}</p>
            <input
              type="file"
              accept={doc.label?.toLowerCase()?.includes("tariff") ? ".pdf,.jpg,.jpeg,.png,.xlsx,.xls" : ".pdf,.jpg,.jpeg,.png"}
              onChange={(e) => handleFileUpload(doc.key, e.target.files[0])}
              className="hidden"
              id={doc.key}
            />
            <label htmlFor={doc.key} className="btn-primary mt-3 cursor-pointer">
              <Upload className="h-4 w-4 mr-2" />
              Choose File
            </label>
          </div>
        ) : (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <FileText className="h-5 w-5 text-green-600" />
                <div>
                  <p className="text-sm font-medium text-green-800">{documents[doc.key].name}</p>
                  <p className="text-xs text-green-600">{(documents[doc.key].size / 1024 / 1024).toFixed(2)} MB</p>
                </div>
              </div>
              <CheckCircle className="h-5 w-5 text-green-600" />
            </div>
            {uploadProgress[doc.key] && uploadProgress[doc.key] < 100 && (
              <div className="mt-2">
                <div className="bg-green-200 rounded-full h-2">
                  <div className="bg-green-600 h-2 rounded-full transition-all duration-300" style={{ width: `${uploadProgress[doc.key]}%` }} />
                </div>
                <p className="text-xs text-green-600 mt-1">{uploadProgress[doc.key]}% ready</p>
              </div>
            )}
          </div>
        )}

        {errors[doc.key] && <p className="form-error mt-2">{errors[doc.key]}</p>}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <div className="bg-gradient-to-r from-teal-500 to-cyan-500 p-3 rounded-xl">
              <Heart className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">SamHealth</h1>
              <p className="text-sm text-teal-600">Hospital Registration Portal</p>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Register Your Hospital</h2>
          <p className="text-gray-600">Join our network and start processing insurance claims seamlessly</p>
        </div>

        {/* Progress Steps */}
        {!submitSuccess && (
          <div className="mb-8">
            <div className="flex items-center justify-center">
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isActive = currentStep === step.id;
                const isCompleted = currentStep > step.id;

                return (
                  <div key={step.id} className="flex items-center">
                    {/* Step Circle */}
                    <div className="flex flex-col items-center">
                      <div className={`flex items-center justify-center w-16 h-16 rounded-full border-2 transition-all duration-300 ${isActive
                          ? 'bg-teal-500 border-teal-500 text-white shadow-lg'
                          : isCompleted
                            ? 'bg-gray-100 border-gray-300 text-gray-400'
                            : 'bg-gray-50 border-gray-200 text-gray-400'
                        }`}>
                        <Icon className="h-7 w-7" />
                      </div>

                      {/* Step Label */}
                      <div className="mt-3 text-center max-w-24">
                        <p className={`text-sm font-medium leading-tight ${isActive ? 'text-teal-600' : 'text-gray-500'
                          }`}>
                          {step.title}
                        </p>
                      </div>
                    </div>

                    {/* Connector Line */}
                    {index < steps.length - 1 && (
                      <div className={`h-0.5 w-16 mx-4 transition-colors duration-300 ${isCompleted ? 'bg-teal-500' : 'bg-gray-200'
                        }`} />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Form Content */}
        <div className="card-medical mb-8">
          {renderStepContent()}
        </div>

        {/* Navigation Buttons */}
        {!submitSuccess && (
          <div className="flex justify-between items-center">
            <button
              onClick={prevStep}
              disabled={currentStep === 1}
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${currentStep === 1
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'
                }`}
            >
              <ArrowLeft className="h-5 w-5" />
              <span>Previous</span>
            </button>

            {/* Step indicator */}
            <div className="text-sm text-gray-500 hidden md:block">
              Step {currentStep} of {steps.length}
            </div>

            {currentStep < 6 ? (
              <button
                onClick={nextStep}
                className="flex items-center space-x-2 btn-primary hover:shadow-lg transform hover:scale-105 transition-all duration-200"
              >
                <span>Next</span>
                <ArrowRight className="h-5 w-5" />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="flex items-center space-x-2 btn-success disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-lg transform hover:scale-105 transition-all duration-200"
              >
                {loading ? (
                  <>
                    <Loader className="h-5 w-5 animate-spin" />
                    <span>Submitting...</span>
                  </>
                ) : (
                  <>
                    <CheckCircle className="h-5 w-5" />
                    <span>Submit Application</span>
                  </>
                )}
              </button>
            )}
          </div>
        )}

        {/* Help Section */}
        <div className="mt-8 text-center">
          <div className="bg-white/60 backdrop-blur-sm rounded-lg p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Need Help?</h3>
            <p className="text-sm text-gray-600 mb-4">
              Our support team is here to assist you with the registration process
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-6">
              <a href="mailto:support@samriddhihealthcare.com" className="flex items-center text-teal-600 hover:text-teal-700 transition-colors">
                <Mail className="h-4 w-4 mr-2" />
                support@samriddhihealthcare.com
              </a>
              <a href="tel:+91-1800-XXX-XXXX" className="flex items-center text-teal-600 hover:text-teal-700 transition-colors">
                <Phone className="h-4 w-4 mr-2" />
                +91 1800-XXX-XXXX
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            © 2024 SamHealth. All rights reserved. |
            <a href="#" className="hover:text-teal-600 ml-1">Privacy Policy</a> |
            <a href="#" className="hover:text-teal-600 ml-1">Terms of Service</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HospitalRegistration;